import { Dispatch, FC, SetStateAction, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, FormProvider } from 'react-hook-form'
import * as Yup from 'yup'
import { InputDateWrapper } from '../../../../../../components/UI/Form/Input'
import { CheckWrapper } from '../../../../../../components/UI/Form/Input'
import moment from 'moment'
import InputNumberWrapper2 from '../../../../../../components/UI/Form/Input/numberWrapper2'

interface Props {
    show: boolean
    setShow: Dispatch<SetStateAction<boolean>>
    onConfirm: (data: { fechaIni: string; fechaFin: string; checkin: boolean; impresion: boolean }) => void
}

const generarReservaSchema = Yup.object().shape({
    FechaInicio: Yup.string().required('Fecha inicio es requerida'),
    FechaFin: Yup.string().required('Fecha fin es requerida'),
    Checkin: Yup.boolean(),
})

const ModalGenerarReserva: FC<Props> = ({ show, setShow, onConfirm }) => {
    const handleClose = () => {
        setShow(false)
        reset()
    }

    const methods = useForm({
        resolver: yupResolver(generarReservaSchema),
        defaultValues: {
            dias: 0,
            FechaInicio: moment().format('YYYY-MM-DD'),
            FechaFin: moment().format('YYYY-MM-DD'),
            Checkin: true,
            Impresion: true,
        },
    })

    const {
        register,
        setValue,
        handleSubmit,
        watch,
        formState: { errors },
        reset,
    } = methods

    const dias = watch('dias')
    const fechaInicio = watch('FechaInicio')
    const fechaFin = watch('FechaFin')

    useEffect(() => {
        if (dias) {
            if(dias < 0) setValue('dias', 0)
            const newFechaFin = moment(fechaInicio).add(dias, 'days').format('YYYY-MM-DD')
            setValue('FechaFin', newFechaFin)
        }
    }, [dias])

    useEffect(() => {
        if (fechaInicio && fechaFin) {
        const inicio = moment(fechaInicio)
        const fin = moment(fechaFin)

        if (fin.isBefore(inicio)) {
            console.log('error')
            return
        }

        const diferencia = fin.diff(inicio, 'days')
        setValue('dias', diferencia)
        }
    }, [fechaInicio, fechaFin])


    useEffect(() => {
        if (show) {
            setValue('FechaInicio', moment().format('YYYY-MM-DD'))
            setValue('FechaFin', moment().add(14, 'days').format('YYYY-MM-DD'))
            setValue('Checkin', true)
            setValue('Impresion', true)
        }
    }, [show, setValue])

    const onSubmit = (data: any) => {
        onConfirm({
            fechaIni: moment(data.FechaInicio).format('YYYY-MM-DD'),
            fechaFin: moment(data.FechaFin).format('YYYY-MM-DD'),
            checkin: data.Checkin || false,
            impresion: !!data.Impresion,
        })
        handleClose()
    }

    return (
        <Modal
            className='modal fade'
            show={show}
            dialogClassName='modal-md'
            aria-hidden='true'
            onHide={handleClose}
        >
            <div className='modal-content'>
                <div className='modal-header'>
                    <h5 className='modal-title'>Generar Reserva</h5>
                    <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
                        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
                    </div>
                </div>
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='modal-body'>
                            <div className='row mb-3'>
                                <div className='mb-2 col-sm-12 col-lg-7'>
                                    <InputNumberWrapper2
                                        labelText='Dias'
                                        name='dias'
                                        textPlaceholder='Escribe los dias'
                                        required
                                        min={0}
                                    />
                                </div>
                                <div className='col-6'>
                                    <InputDateWrapper
                                        labelText='Fecha Inicio'
                                        name='FechaInicio'
                                        required
                                    />
                                </div>
                                <div className='col-6'>
                                    <InputDateWrapper
                                        labelText='Fecha Fin'
                                        name='FechaFin'
                                        required
                                        minValue={watch('FechaInicio')}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-4'>
                                    <CheckWrapper
                                        labelText='Reserva y Checkin'
                                        name='Checkin'
                                        disabled={true}
                                    />
                                </div>
                                <div className='col-4'>
                                    <CheckWrapper
                                        labelText='Impresión'
                                        name='Impresion'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-light' onClick={handleClose}>
                                Cancelar
                            </button>
                            <button type='submit' className='btn btn-primary'>
                                Generar
                            </button>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </Modal>
    )
}

export { ModalGenerarReserva }
